﻿export function calcularTamanhoHeader() {
  let tamanhoHeaderAtual = 0;

  const headerQuestionario = document.querySelector('.header-questionario');
  
  if(headerQuestionario){
    tamanhoHeaderAtual =
    headerQuestionario.offsetHeight < 40 ? 40 : headerQuestionario.offsetHeight;

    return tamanhoHeaderAtual;
  }

  const headers = document.querySelectorAll(".header-empregare");
  if (headers && headers.length > 0) {
    headers.forEach((header) => {
      if (header.offsetHeight > 0) {
        tamanhoHeaderAtual =
          header.offsetHeight < 40 ? 40 : header.offsetHeight;
      }
    });
  }

  return tamanhoHeaderAtual;
}
